import { BasePlainResource } from "./BasePlainResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
import { ApplicationStatusId, ApplicationStatus, DocumentStatus } from "@ploy-lib/types";
class ApplicationStatusesResource extends BasePlainResource {
    constructor() {
        super(...arguments);
        this.applicationStatusId = ApplicationStatusId.NotSet;
        this.applicationStatus = ApplicationStatus.NotSet;
        this.documentStatus = DocumentStatus.NotSet;
        this.canSendToEsign = false;
        this.canEditRegNumber = false;
        this.fullPostProcessAfterPayout = false;
        this.canEditChassisNumber = false;
        this.canEditInvoiceNoRef = false;
        this.canEditDeliveryDate = false;
        this.canEditDueDay = false;
    }
    pk() {
        return this.id?.toString() || "unknown";
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            invalidIfStale: true,
            dataExpiryLength: Infinity
        };
    }
}
ApplicationStatusesResource.urlRoot = legacyApiResourceUrl("AppLoanLeasing/GetApplicationStatuses");
export { ApplicationStatusesResource };
//# sourceMappingURL=ApplicationStatusesResource.js.map